import './form.scss';

var $cf7 = $('.wpcf7');
$cf7.each(function () {
  this.addEventListener('wpcf7mailsent', function () {
    var $form = $(this),
      $cont = $form.closest('.form_container'),
      cls = $cont.data('tclass');

    $form.find('input, textarea').parent().parent().removeClass('focus');

    $cont.toggleClass(cls);
  }, false);
});
